// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
const currentYear = siteData.current_year
const logoUrl = siteData.images_url + 'logo/adventist_church_in_auc_text_vertical_charcoal.svg'

class Footer extends React.Component {
	render() {
		return (
			<footer className="footer">
				<div className="-inner">
					<div className="-logo">
						<p>
							<a href="http://adventist.org.au" target="_blank">
								<img src={ logoUrl } alt="Australian Union Conference of Seventh-day Adventists" />
							</a>
						</p>
					</div>

					<p>
						289 Maroondah Highway, Ringwood, Vic 3134, Australia<br />
						PH: +613 9871 7555 &nbsp; &middot; &nbsp; Fax: +613 9870 7715<br /><br />
						&copy; { currentYear } <a className="plain" href="https://adventist.org.au">Australian Union Conference of the Seventh-day Adventist Church</a>
						<br />
						Website by <a className="plain" href="http://alexgreendesign.com" target="_blank">Alex Green Design</a>
					</p>
				</div>
			</footer>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
	return {

	}
}

export default connect( mapStateToProps, mapDispatchToProps )( Footer )



// WEBPACK FOOTER //
// ./components/Footer/Footer.jsx